<!--
/**
* @name: Add.vue
* @description: 添加打折活动页面
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :title="isView ? '查看打折活动' : isEdit ? '编辑打折活动' : '新增打折活动'">
    <template v-if="!isView">
      <y-form titleAlign="right" titleWidth="100px" contentWidth="600px">
        <y-form-item title="销售渠道:" required>
          <k-select clearable block v-model="editPara.saleChannelCode" :class="css.inputW">
            <k-option
              v-for="item in channelList"
              :key="item.code"
              :selected="editPara.saleChannelCode == item.code"
              :value="item.code"
              :label="item.name"
              >{{ item.name }}</k-option
            >
          </k-select>
        </y-form-item>
        <y-form-item title="活动名称:" required>
          <k-input placeholder="请输入活动名称" block :class="css.inputW" clearable v-model="editPara.activityName"></k-input>
        </y-form-item>
        <y-form-item title="活动图片:" align="top">
          <div class="row">
            <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploaded"></y-upload-file>
            <y-image
              @delete="onDelete"
              v-dragging="{ list: activityImgList, item: img, group: 'image' }"
              v-for="(img, index) in activityImgList"
              :key="index"
              :index="index"
              :src="img"
            ></y-image>
          </div>
          <div class="mt-1">（只能上传1张，每张大小不超过 3M）</div>
        </y-form-item>
        <y-form-item title="推广渠道:" required>
          <div>
            <k-radio v-model="editPara.extendChannel" value="C_CLIENT">C端</k-radio>
            <k-radio v-model="editPara.extendChannel" value="STORE">门店</k-radio>
            <k-radio v-model="editPara.extendChannel" value="NEW_CUSTOMER">C端新客</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="适用场景:" required>
          <div>
            <k-radio v-for="(item, index) in suitSceneList" :key="index" v-model="editPara.suitScene" :value="item.value">{{ item.name }}</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="场景活动编号:" required v-if="editPara.suitScene == 'live'">
          <k-input style="width: 140px;" placeholder="请输入场景活动编号" block v-model="editPara.suitSceneNo"></k-input>
        </y-form-item>
        <y-form-item title="门店限制:" v-if="editPara.extendChannel == 'STORE'">
          <div>
            <k-radio v-model="editPara.isLimitShop" :value="false">不限制</k-radio>
            <k-radio v-model="editPara.isLimitShop" :value="true">限制</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="选择门店:" v-if="editPara.extendChannel == 'STORE' && editPara.isLimitShop == true" required align="top">
          <ol class="ml-2">
            <li v-for="(item, index) in packStoreList" :key="index" class="mb-1" style="list-style: decimal;">
              推广公司：
              <k-auto-complete
                ref="au"
                :data="companyList"
                v-model="item.cpId"
                key-field="code"
                value-field="name"
                search-field="name"
                layer-width=""
                placeholder="请选择推广公司"
                @focus="onFocus"
                @toggle="changeCompany(item.cpId, index)"
                @input="onInput"
                :empty="empty"
                :text="text"
                style="max-width: 200px; display: inline-block;"
              >
                <div slot-scope="{ row }" :key="row.code" class="list">
                  <span class="name">{{ row.name }}</span>
                </div>
              </k-auto-complete>
              ， 门店：
              <k-select2
                v-model="item.clientId"
                :data="item.dealerList"
                placeholder="请选择门店"
                keyField="id"
                textField="shopName"
                search-field="shopName"
                style="width: 200px;"
                layer-width="auto"
                layerMinWidthEqual
                :nearby="true"
              >
              </k-select2>
              <span class="ml-2">
                <a href="javascript:;" class="iconfont k-icon-add" title="添加" @click="onAddStore(index)"></a>&nbsp;
                <a href="javascript:;" class="iconfont k-icon-close-circle" title="删除" @click="onDelStore(index)" v-if="index > 0"></a>
              </span>
            </li>
          </ol>
        </y-form-item>
        <y-form-item title="优惠承担方:" required align="top">
          <div :class="css.box">
            <k-radio v-model="editPara.bear" value="PLATFORM">平台</k-radio>
            <k-radio v-model="editPara.bear" value="SUPPLIER">供应商</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="使用范围:" required>
          <div>
            <k-radio v-model="editPara.suitableType" value="GOODS">商品</k-radio>
            <k-radio v-model="editPara.suitableType" value="CATEGORY" :disabled="editPara.bear == 'SUPPLIER' ? true : false">分类</k-radio>
            <k-radio v-model="editPara.suitableType" value="BRAND" :disabled="editPara.bear == 'SUPPLIER' ? true : false">品牌</k-radio>
          </div>
        </y-form-item>
        <y-form-item v-if="editPara.suitableType == 'GOODS'" title="商品货号:" required>
          <div :class="css.flex">
            <k-input
              style="width: 280px;"
              :placeholder="editPara.bear == 'PLATFORM' ? '请输入商品货号，用英文逗号隔开' : '只能输入单个货号'"
              clearable
              v-model="goodsSns"
            ></k-input>
            <a @click="addGoodsSns">添加</a>
          </div>
        </y-form-item>
        <k-table
          has-index
          max-height="300px"
          :data="goodsSnsList"
          :rightFixedNumber="1"
          :class="css.tableW"
          :columns="goodsSnsColumns()"
          v-if="this.goodsSnsList.length > 0 && editPara.suitableType == 'GOODS'"
        ></k-table>
        <y-form-item v-show="editPara.suitableType == 'BRAND'" title="选择品牌:" required>
          <k-select2
            v-model="brandIds"
            :class="css.inputW"
            :data="brandList"
            search-field="gbname"
            text-field="gbname"
            key-field="gbcode"
            layer-width="auto"
            layerMinWidthEqual
            :nearby="true"
            placeholder="请选择商品品牌"
            ref="selectBrand"
          >
          </k-select2>
        </y-form-item>
        <y-form-item v-show="editPara.suitableType == 'CATEGORY'" title="选择分类:" required>
          <k-select2
            v-model="catIds"
            :class="css.inputW"
            :data="catList"
            search-field="name"
            text-field="parentNameUrl"
            key-field="id"
            layer-width="auto"
            layerMinWidthEqual
            :nearby="true"
            placeholder="请选择商品分类"
            ref="selectCat"
          >
          </k-select2>
        </y-form-item>
        <y-form-item v-if="editPara.bear == 'SUPPLIER' && editPara.suitableType == 'GOODS'" title="适用批次号:" required>
          <k-select2
            v-model="saleBatchNoList"
            :class="css.inputW"
            :data="batchList"
            search-field="code"
            text-field="code"
            key-field="code"
            layer-width="auto"
            layerMinWidthEqual
            :nearby="true"
            placeholder="请选择适用批次号"
            ref="selectBatch"
          >
          </k-select2>
        </y-form-item>
        <y-form-item title="活动类型:" required>
          <div>
            <k-radio v-model="editPara.discountType" value="PERCENT">按百分比</k-radio>
            <k-radio v-model="editPara.discountType" value="AMOUNT">按商品金额</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="活动门槛:" required>
          <div>
            <k-radio v-model="editPara.thresholdType" value="QUANTITY">按商品数量</k-radio>
            <k-radio v-model="editPara.thresholdType" value="AMOUNT">按商品金额</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="优惠方式:" required align="top">
          <span :class="css.tip" v-if="!editPara.discountType || !editPara.thresholdType">请先选择活动类型和活动门槛</span>
          <ol class="ml-2" v-if="editPara.discountType == 'PERCENT' && editPara.thresholdType == 'AMOUNT'">
            <li v-for="(item, index) in packList" :key="index" class="mb-1" style="list-style: decimal;">
              满
              <k-input
                :disabled="isView"
                placeholder="请输入数量"
                style="max-width: 100px;"
                v-model="packList[index].threshold"
                type="number"
                min="1"
              >
              </k-input>
              元&#12288; 打
              <k-input
                @keydown.native="clearInput1"
                :disabled="isView"
                placeholder="请输入数量"
                style="max-width: 100px;"
                v-model="packList[index].reduce"
                type="number"
                min="1"
                max="10"
              >
              </k-input>
              折
              <span class="ml-2" v-if="!isView">
                <a href="javascript:;" class="iconfont k-icon-add" title="添加" @click="onAdd(index)"></a>&nbsp;
                <a href="javascript:;" class="iconfont k-icon-close-circle" title="删除" @click="onDel(index)" v-if="index > 0"></a>
              </span>
            </li>
          </ol>
          <ol class="ml-2" v-if="editPara.discountType == 'PERCENT' && editPara.thresholdType == 'QUANTITY'">
            <li v-for="(item, index) in packList" :key="index" class="mb-1" style="list-style: decimal;">
              满
              <k-input
                @keydown.native="clearInput"
                :disabled="isView"
                placeholder="请输入数量"
                style="max-width: 100px;"
                v-model="packList[index].threshold"
                type="number"
                min="1"
              >
              </k-input>
              件&#12288; 打
              <k-input
                @keydown.native="clearInput1"
                :disabled="isView"
                placeholder="请输入数量"
                style="max-width: 100px;"
                v-model="packList[index].reduce"
                type="number"
                min="1"
                max="10"
              >
              </k-input>
              折
              <span class="ml-2" v-if="!isView">
                <a href="javascript:;" class="iconfont k-icon-add" title="添加" @click="onAdd(index)"></a>&nbsp;
                <a href="javascript:;" class="iconfont k-icon-close-circle" title="删除" @click="onDel(index)" v-if="index > 0"></a>
              </span>
            </li>
          </ol>
          <ol class="ml-2" v-if="editPara.discountType == 'AMOUNT' && editPara.thresholdType == 'QUANTITY'">
            <li v-for="(item, index) in packList" :key="index" class="mb-1" style="list-style: decimal;">
              满
              <k-input
                @keydown.native="clearInput"
                :disabled="isView"
                placeholder="请输入数量"
                style="max-width: 100px;"
                v-model="packList[index].threshold"
                type="number"
                min="1"
              >
              </k-input>
              件&#12288; 减
              <k-input :disabled="isView" placeholder="请输入数量" style="max-width: 100px;" v-model="packList[index].reduce" type="number" min="1">
              </k-input>
              元
              <span class="ml-2" v-if="!isView">
                <a href="javascript:;" class="iconfont k-icon-add" title="添加" @click="onAdd(index)"></a>&nbsp;
                <a href="javascript:;" class="iconfont k-icon-close-circle" title="删除" @click="onDel(index)" v-if="index > 0"></a>
              </span>
            </li>
          </ol>
          <ol class="ml-2" v-if="editPara.discountType == 'AMOUNT' && editPara.thresholdType == 'AMOUNT'">
            <li v-for="(item, index) in packList" :key="index" class="mb-1" style="list-style: decimal;">
              满
              <k-input
                :disabled="isView"
                placeholder="请输入数量"
                style="max-width: 100px;"
                v-model="packList[index].threshold"
                type="number"
                min="1"
              >
              </k-input>
              元&#12288; 减
              <k-input :disabled="isView" placeholder="请输入数量" style="max-width: 100px;" v-model="packList[index].reduce" type="number" min="1">
              </k-input>
              元
              <span class="ml-2" v-if="!isView">
                <a href="javascript:;" class="iconfont k-icon-add" title="添加" @click="onAdd(index)"></a>&nbsp;
                <a href="javascript:;" class="iconfont k-icon-close-circle" title="删除" @click="onDel(index)" v-if="index > 0"></a>
              </span>
            </li>
          </ol>
        </y-form-item>
        <y-form-item title="活动时间:" required>
          <DatePicker
            :editable="false"
            type="datetimerange"
            @on-change="changeDate"
            :value="effectDate"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择使用有效期"
            style="width: 280px;"
          ></DatePicker>
        </y-form-item>
      </y-form>
    </template>
    <template v-else>
      <y-form titleAlign="right" titleWidth="100px" contentWidth="600px">
        <y-form-item title="销售渠道:" required>
          <span>{{ editPara.saleChannelName }}</span>
        </y-form-item>
        <y-form-item title="活动名称:" required>
          <span>{{ editPara.activityName }}</span>
        </y-form-item>
        <y-form-item title="活动图片:" align="top">
          <div class="row">
            <y-image
              v-dragging="{ list: activityImgList, item: img, group: 'image' }"
              v-for="(img, index) in activityImgList"
              :key="index"
              :index="index"
              :src="img"
            ></y-image>
          </div>
          <div class="mt-1">（只能上传1张，每张大小不超过 ？M）</div>
        </y-form-item>
        <y-form-item title="推广渠道:" required>
          <span>{{ editPara.extendChannel == 'C_CLIENT' ? 'C端' : editPara.extendChannel == 'STORE' ? '门店' : 'C端新客' }}</span>
        </y-form-item>
        <y-form-item title="适用场景:" required>
          <span>{{ editPara.suitScene == 'live' ? '直播' : '普通' }}</span>
        </y-form-item>
        <y-form-item title="场景活动编号:" required v-if="editPara.suitScene == 'live'">
          <span>{{ editPara.suitSceneNo }}</span>
        </y-form-item>
        <y-form-item title="门店限制:" v-if="editPara.extendChannel == 'STORE'">
          <span>{{ editPara.isLimitShop == true ? '限制' : '不限制' }}</span>
        </y-form-item>
        <y-form-item title="选择门店:" required align="top" v-if="editPara.extendChannel == 'STORE' && editPara.isLimitShop == true">
          <ol class="ml-2">
            <li v-for="(item, index) in packStoreList" :key="index" class="mb-1" style="list-style: decimal;">
              推广公司：
              <span>{{ item.cpId | filterCompany(companyList) }}</span>
              ， 门店：
              <span>{{ item.clientId | filterDealers(item.dealerList) }}</span>
            </li>
          </ol>
        </y-form-item>
        <y-form-item title="优惠承担方:" required align="top">
          <div :class="css.box">
            <span v-if="editPara.bear == 'PLATFORM'">平台</span>
            <span v-if="editPara.bear == 'SUPPLIER'">供应商</span>
          </div>
        </y-form-item>
        <y-form-item title="使用范围:" required>
          <span v-if="editPara.suitableType == 'GOODS'">商品</span>
          <span v-if="editPara.suitableType == 'CATEGORY'">分类</span>
          <span v-if="editPara.suitableType == 'BRAND'">品牌</span>
        </y-form-item>
        <y-form-item v-if="editPara.suitableType == 'GOODS'" title="商品货号:" required>
          <span>{{ goodsSns }}</span>
        </y-form-item>
        <k-table
          has-index
          max-height="300px"
          :data="goodsSnsList"
          :rightFixedNumber="1"
          :columns="goodsSnsColumns().splice(0, 2)"
          :class="css.tableW"
          v-if="this.goodsSnsList.length > 0 && editPara.suitableType == 'GOODS'"
        ></k-table>
        <y-form-item v-if="editPara.suitableType == 'BRAND'" title="选择品牌:" required>
          <span>{{ brandIds | filterBrand(this.brandList) }}</span>
        </y-form-item>
        <y-form-item v-if="editPara.suitableType == 'CATEGORY'" title="选择分类:" required>
          <span>{{ catIds | filterCat(this.catList) }}</span>
        </y-form-item>
        <y-form-item v-if="editPara.bear == 'SUPPLIER'" title="适用批次号:" required>
          <span>{{ saleBatchNoList | filterBatch(this.batchList) }}</span>
        </y-form-item>
        <y-form-item title="活动类型:" required>
          <span>{{ editPara.discountType == 'PERCENT' ? '按百分比' : '按商品金额' }}</span>
        </y-form-item>
        <y-form-item title="活动门槛:" required>
          <span>{{ editPara.thresholdType == 'QUANTITY' ? '按商品数量' : '按商品金额' }}</span>
        </y-form-item>
        <y-form-item title="优惠方式:" required align="top">
          <ol class="ml-2" v-if="editPara.discountType == 'PERCENT' && editPara.thresholdType == 'AMOUNT'">
            <li v-for="(item, index) in packList" :key="index" class="mb-1" style="list-style: decimal;">
              满 {{ packList[index].threshold }} 元&#12288; 打 {{ packList[index].reduce }} 折
            </li>
          </ol>
          <ol class="ml-2" v-if="editPara.discountType == 'PERCENT' && editPara.thresholdType == 'QUANTITY'">
            <li v-for="(item, index) in packList" :key="index" class="mb-1" style="list-style: decimal;">
              满 {{ packList[index].threshold }} 件&#12288; 打 {{ packList[index].reduce }} 折
            </li>
          </ol>
          <ol class="ml-2" v-if="editPara.discountType == 'AMOUNT' && editPara.thresholdType == 'QUANTITY'">
            <li v-for="(item, index) in packList" :key="index" class="mb-1" style="list-style: decimal;">
              满 {{ packList[index].threshold }} 件&#12288; 减 {{ packList[index].reduce }} 元
            </li>
          </ol>

          <ol class="ml-2" v-if="editPara.discountType == 'AMOUNT' && editPara.thresholdType == 'AMOUNT'">
            <li v-for="(item, index) in packList" :key="index" class="mb-1" style="list-style: decimal;">
              满 {{ packList[index].threshold }} 元&#12288; 减 {{ packList[index].reduce }} 元
            </li>
          </ol>
        </y-form-item>
        <y-form-item title="活动时间:" required>
          <span>{{ editPara.startTime }}~{{ editPara.endTime }}</span>
        </y-form-item>
      </y-form>
    </template>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_LIST,
  NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST,
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
  NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_SAVE,
  NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_UPDATE,
  NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_DETAIL,
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
  NESTLE_MARKETING_BACK_SERVER_BONUS_SALE_BATCH_NO_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODSCODESALE
} from '@/assets/modules/apiList';

const initEditPara = () => ({
  saleChannelCode: '',
  activityName: '',
  discountType: '',
  bear: '',
  thresholdType: '',
  activityImgUrl: '',
  startTime: '',
  endTime: '',
  isLimitShop: '',
  extendChannel: '',
  suitableType: '',
  suitScene: '', //适用场景
  suitSceneNo: '',
  suitSourceList: [],
  activityRuleDTOList: [],
  storeIdList: []
});
export default {
  data() {
    return {
      effectDate: [],
      editPara: initEditPara(),
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      activityImgList: [],
      suitSceneList: [],
      channelList: [],
      brandList: [], //品牌列表
      brandIds: [], //品牌ID
      saleBatchNoList: [],
      batchList: [],
      catList: [], //分类列表
      catIds: [], //分类ID
      text: '',
      empty: '',
      companyList: [],
      packList: [],
      packStoreList: [],
      packCell: {
        threshold: '',
        reduce: ''
      },
      packStoreCell: {
        cpId: '',
        clientId: [],
        dealerList: []
      },
      goodsSns: '',
      goodsSnsList: [],
      isSaving: false,
      isView: false,
      isEdit: false,
      originData: {}
    };
  },
  filters: {
    filterDealers(code, arr) {
      let tmp = [];
      arr.forEach(a => {
        if (code.indexOf(a.id) > -1) {
          tmp.push(a.shopName);
        }
      });
      return tmp.join(',');
    },
    filterCompany(code, arr) {
      let tmp = [];
      arr.forEach(a => {
        if (code == a.code) {
          tmp.push(a.name);
        }
      });
      return tmp.join(',');
    },
    filterBrand(code, arr) {
      let tmp = [];
      arr.forEach(a => {
        if (code.indexOf(a.gbcode) != -1) {
          tmp.push(a.gbname);
        }
      });
      return tmp.join(',');
    },
    filterCat(code, arr) {
      let tmp = [];
      arr.forEach(a => {
        if (code.indexOf(a.id + '') != -1) {
          tmp.push(a.name);
        }
      });
      return tmp.join(',');
    }
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        if (
          !para.saleChannelCode ||
          !para.activityName ||
          !para.discountType ||
          !para.bear ||
          !para.thresholdType ||
          !this.packList[this.packList.length - 1].threshold ||
          !this.packList[this.packList.length - 1].reduce ||
          !this.effectDate ||
          !para.suitableType ||
          !para.extendChannel ||
          !para.suitScene ||
          (para.suitScene == 'live' && !para.suitSceneNo) ||
          (para.extendChannel == 'STORE' && para.isLimitShop == true && !this.packStoreList[this.packStoreList.length - 1].clientId) ||
          (para.extendChannel == 'STORE' && para.isLimitShop == true && this.packStoreList[this.packStoreList.length - 1].clientId.length === 0) ||
          (para.bear == 'SUPPLIER' && this.saleBatchNoList && this.saleBatchNoList.length === 0) ||
          (para.suitableType == 'GOODS' && this.goodsSnsList.length === 0) ||
          (para.suitableType == 'BRAND' && this.brandIds && this.brandIds.length === 0) ||
          (para.suitableType == 'CATEGORY' && this.catIds && this.catIds.length === 0)
        ) {
          status = true;
        }
      }
      return status;
    }
  },
  watch: {
    'editPara.suitableType': {
      handler(newValue) {
        if (!this.isView) {
          if (newValue != 'BRAND' && newValue != '') {
            this.$refs.selectBrand.searchText = '';
          }
          if (newValue != 'CATEGORY' && newValue != '') {
            this.$refs.selectCat.searchText = '';
          }
        }
      },
      immediate: true
    },
    'editPara.bear': {
      handler(newValue, oldValue) {
        if (oldValue == 'PLATFORM') {
          if (newValue == 'SUPPLIER') {
            this.editPara.suitableType = '';
            this.saleBatchNoList = [];
            this.batchList = [];
            this.goodsSns = '';
          }
        }
      },
      immediate: true
    },
    'editPara.discountType'(v, o) {
      if (this.isEdit) {
        if (v && o) {
          this.packList = [];
          if (v) {
            if (v && this.editPara.thresholdType) {
              this.packList.push(Object.assign({}, this.packCell));
            }
          }
        }
      }
      if (!this.isEdit && !this.isView) {
        this.packList = [];
        if (v) {
          if (v && this.editPara.thresholdType) {
            this.packList.push(Object.assign({}, this.packCell));
          }
        }
      }
    },
    'editPara.thresholdType'(v, o) {
      if (this.isEdit) {
        if (v && o) {
          this.packList = [];
          if (v) {
            if (v && this.editPara.discountType) {
              this.packList.push(Object.assign({}, this.packCell));
            }
          }
        }
      }
      if (!this.isEdit && !this.isView) {
        this.packList = [];
        if (v) {
          if (v && this.editPara.discountType) {
            this.packList.push(Object.assign({}, this.packCell));
          }
        }
      }
    },
    goodsSnsList: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (this.editPara.bear == 'SUPPLIER') {
            this.getBatchList(newValue.map(v => v.goodsCodeSale)[0]);
          }
        }
      },
      immediate: true
    },
    batchList: {
      handler(newValue) {
        if (newValue && newValue.length === 0) {
          this.saleBatchNoList = [];
        }
      },
      immediate: true
    }
  },
  methods: {
    onDeleteGoods(row) {
      this.$dialog({
        title: '提示',
        content: '确认删除当前商品吗？',
        ok: () => {
          for (let index = 0; index < this.goodsSnsList.length; index++) {
            if (this.goodsSnsList[index].id == row.id) {
              this.goodsSnsList.splice(index, 1);
              break;
            }
          }
        }
      });
    },
    addGoodsSns() {
      let { tip } = this.$root;
      if (!this.goodsSns) {
        return tip('请输入商品货号');
      }
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODSCODESALE,
        para: { goodsCodeSaleList: this.goodsSns.split(',') }
      }).then(res => {
        if (res) {
          let msg = '';
          let Arr = [];
          res.forEach(v => {
            // 判断该商品是否已被添加过
            if (!this.goodsSnsList) {
              this.goodsSnsList = [];
            }
            if (this.goodsSnsList.map(y => y.goodsCodeSale).indexOf(v.goodsCodeSale) < 0) {
              if (this.goodsSnsList.length < 50) {
                this.goodsSnsList.push(v);
              } else {
                msg = '最多只能添加50个商品';
              }
            } else {
              Arr.push(v.goodsCodeSale);
              msg = `${Arr}商品已被选择`;
            }
          });
          // 输入多个商品货号 某几个不正确
          if (res.length !== new Set(this.goodsSns.split(',')).size) {
            const arr = this.goodsSns.split(',').filter(item => !res.map(y => y.goodsCodeSale).includes(item));
            msg = `添加失败！商品货号${arr}在系统不存在`;
          }
          if (msg) return tip(msg);
          this.goodsSns = '';
        } else {
          // 输入一个商品货号 且货号不存在
          return tip('该商品货号不存在，请输入正确的商品货号');
        }
      });
    },
    goodsSnsColumns() {
      return [
        {
          name: '商品货号',
          field: 'goodsCodeSale',
          style: {
            width: 80,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '20px'
          }
        },
        {
          name: '商品名称',
          field: 'goodsNameSale',
          style: {
            width: 150,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '18px'
          }
        },
        {
          name: '操作',
          field: 'action',
          style: {
            width: 80,
            textAlign: 'center',
            'line-height': '18px'
          },
          customRender: row => {
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDeleteGoods(row);
                }}
              >
                删除
              </a>
            );
            return <div>{deleteButton}</div>;
          }
        }
      ];
    },
    onFocus() {},
    onToggle(e) {
      console.log('toggle', e);
    },
    onInput(text) {},
    clearInput(e) {
      let key = e.key;
      if (key === 'e' || key === 'E' || key === '+' || key === '-' || key === '.') {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    clearInput1(e) {
      let key = e.key;
      if (key === 'e' || key === 'E' || key === '+' || key === '-') {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    onUploaded(data) {
      this.activityImgList = [];
      this.activityImgList.push(data.data[0].url);
    },
    onAddStore(index) {
      let { tip } = this.$root;
      if (!this.packStoreList[index].clientId || this.packStoreList[index].clientId.length === 0) {
        return tip('请先完善当前列信息');
      }
      this.packStoreList.push(Object.assign({}, this.packStoreCell));
    },
    onDelStore(index) {
      this.packStoreList.splice(index, 1);
    },
    changeCompany(id, index) {
      this.packStoreList[index].dealerList = [];
      // this.packStoreList[index].clientId = [];
      this.getDealersList(id, index);
    },
    getBatchList(params) {
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_BONUS_SALE_BATCH_NO_LIST,
        para: { goodsCodeSale: params }
      }).then(res => {
        let data = [];
        for (let i = 0; i < res.length; i++) {
          data.push({ code: res[i] });
        }
        this.batchList = data;
      });
    },
    getDealersList(id, index) {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_LIST,
        para: { companyCode: id }
      }).then(res => {
        this.packStoreList[index].dealerList = res || [];
      });
    },
    onAdd(index) {
      let { tip } = this.$root;
      if (!this.packList[index].threshold || !this.packList[index].reduce) {
        return tip('请先完善当前列信息');
      }
      this.packList.push(Object.assign({}, this.packCell));
    },
    onDel(index) {
      this.packList.splice(index, 1);
    },
    changeDate(date) {
      this.effectDate = date;
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {}
      }).then(res => {
        this.channelList = res || [];
      });
    },
    getCompanyList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
        para: {}
      }).then(res => {
        this.companyList = res;
      });
    },
    getBrandList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
        para: {}
      }).then(res => {
        this.brandList = res;
      });
    },
    getCatList() {
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST,
        para: { isEnabled: true, rank: 3 }
      }).then(res => {
        this.catList = res;
      });
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: 'discountManagement',
          query: {
            refresh: isRefresh ? new Date() - 0 : 0
          }
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      if (this.$refs.au) {
        this.$refs.au.inputText = '';
      }
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      for (let i = 0; i < this.packList.length; i++) {
        if (this.packList[i].threshold.toString().indexOf('.') != -1) {
          if (this.packList[i].threshold.toString().split('.')[1].length > 2) {
            return tip('优惠方式满XX元,XX最多两位小数');
          }
        }
        if (this.editPara.discountType == 'PERCENT') {
          if (this.packList[i].reduce.toString().indexOf('.') != -1) {
            if (this.packList[i].reduce.toString().split('.')[1].length > 1) {
              return tip('优惠方式打XX折,XX最多一位小数');
            }
          }
          if (this.packList[i].reduce < 1 || this.packList[i].reduce > 10) {
            return tip('优惠方式打XX折,必须是1-10之间的数');
          }
        } else if (this.packList[i].reduce.toString().indexOf('.') != -1) {
          if (this.packList[i].reduce.toString().split('.')[1].length > 2) {
            return tip('优惠方式减XX元,XX最多两位小数');
          }
        }
      }
      if (
        (para.extendChannel == 'STORE' && para.isLimitShop == true && !this.packStoreList[this.packStoreList.length - 1].clientId) ||
        (para.extendChannel == 'STORE' && para.isLimitShop == true && this.packStoreList[this.packStoreList.length - 1].clientId.length === 0)
      ) {
        return tip('请选择门店');
      }

      para.startTime = this.effectDate && this.effectDate.length > 0 ? this.effectDate[0] : '';
      para.endTime = this.effectDate && this.effectDate.length > 0 ? this.effectDate[1] : '';
      if (para.suitableType == 'CATEGORY') {
        para.suitSourceList = this.catIds;
      } else if (para.suitableType == 'BRAND') {
        para.suitSourceList = this.brandIds;
      } else if (para.suitableType == 'GOODS') {
        if (this.goodsSnsList.length > 0) {
          if (this.goodsSnsList.length > 50) {
            return tip('该优惠券最多只能应用于50个商品');
          }
          let arr = [];
          this.goodsSnsList.forEach(v => {
            arr.push(v.goodsCodeSale);
          });
          para.suitSourceList = arr;
        }
      }
      if (this.editPara.bear == 'SUPPLIER') {
        para.saleBatchNoList = this.saleBatchNoList;
      }
      para.activityImgUrl = this.activityImgList[0];
      para.activityRuleDTOList = this.packList;
      let storeIdList = [];
      for (let i = 0; i < this.packStoreList.length; i++) {
        storeIdList = storeIdList.concat(this.packStoreList[i].clientId);
      }
      para.storeIdList = storeIdList;
      if (para.suitScene == 'common') {
        para.suitSceneNo = '';
      }
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_UPDATE : NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_SAVE,
        para
      })
        .then(res => {
          this.isSaving = false;
          this.isLoading = false;
          tip('操作成功');
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    async getActivityDetail(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_DETAIL,
        para: { id: id }
      })
        .then(res => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          this.effectDate = [this.editPara.startTime, this.editPara.endTime];
          if (this.editPara.provideType == 'ONLINE' && this.editPara.receiveLimit == -1) {
            this.limit = -1;
          } else if (this.editPara.provideType == 'ONLINE' && this.editPara.receiveLimit != -1) {
            this.limit = 1;
          }
          let suitSourceList = [];
          for (let i = 0; i < this.editPara.discountActivitySuitVOList.length; i++) {
            suitSourceList.push(this.editPara.discountActivitySuitVOList[i].suitSource);
          }
          let packList = [];
          for (let i = 0; i < this.editPara.activityRuleVOList.length; i++) {
            packList.push({ threshold: this.editPara.activityRuleVOList[i].threshold, reduce: this.editPara.activityRuleVOList[i].reduce });
          }
          this.packList = packList;
          if (this.editPara.discountActivitySupplierBearVOList && this.editPara.discountActivitySupplierBearVOList.length > 0) {
            let discountActivitySupplierBearVOList = [];
            for (let i = 0; i < this.editPara.discountActivitySupplierBearVOList.length; i++) {
              discountActivitySupplierBearVOList.push(this.editPara.discountActivitySupplierBearVOList[i].saleBatchNo);
            }
            this.saleBatchNoList = discountActivitySupplierBearVOList;
          }
          let packStoreList = [];
          for (let i = 0; i < this.editPara.discountActivityCompanyVOList.length; i++) {
            packStoreList.push({
              cpId: this.editPara.discountActivityCompanyVOList[i].companyCode,
              discountActivityStoreVOList: this.editPara.discountActivityCompanyVOList[i].discountActivityStoreVOList,
              dealerList: []
            });
            this.packStoreList = packStoreList;
            this.getDealersList(this.editPara.discountActivityCompanyVOList[i].companyCode, i);
          }
          this.packStoreList.forEach(tt => {
            tt.clientId = [];
            tt.discountActivityStoreVOList.forEach(dd => {
              tt.clientId.push(dd.storeId);
            });
          });
          this.activityImgList.push(res.activityImgUrl);
          this.editPara.suitSourceList = suitSourceList;
          if (this.editPara.suitableType == 'GOODS') {
            this.goodsSns = '';
            this.$fetch({
              api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODSCODESALE,
              para: { goodsCodeSaleList: suitSourceList.join(',').split(',') }
            }).then(i => {
              this.goodsSnsList = i;
            });
          } else if (this.editPara.suitableType == 'CATEGORY') {
            this.catIds = suitSourceList;
          } else if (this.editPara.suitableType == 'BRAND') {
            this.brandIds = suitSourceList;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    //获取适应场景
    getSuitSceneList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: 'APPLICABLE_SCENE'
        }
      }).then(res => {
        this.suitSceneList = res || [];
      });
    }
  },
  created() {
    this.getSuitSceneList();
    this.getChannelList();
    this.getBrandList();
    this.getCatList();
    this.getCompanyList();
    const { id, edit, view } = this.$route.query;
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getActivityDetail(id);
    } else {
      this.packList = [];
      // this.packList.push(Object.assign({}, this.packCell));
      this.packStoreList.push(Object.assign({}, this.packStoreCell));
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, edit, view } = to.query;
    this.editPara = initEditPara();
    this.packList = [];
    this.packStoreList = [];
    this.effectDate = '';
    this.goodsSns = '';
    this.saleBatchNoList = [];
    this.batchList = [];
    this.activityImgList = [];
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
        this.goodsSnsList = [];
      }
      this.getActivityDetail(id);
    } else {
      this.packList = [];
      // this.packList.push(Object.assign({}, this.packCell));
      this.packStoreList.push(Object.assign({}, this.packStoreCell));
      this.isEdit = false;
      this.isView = false;
      this.goodsSnsList = [];
    }
    next();
  }
};
</script>

<style lang="postcss" module="css">
.box {
  display: inline-block;
}

.inputNumberW {
  width: 80px !important;
}

.inputW {
  width: 300px !important;
}

.flex {
  display: flex;
  width: 320px;
  justify-content: space-between;
  align-items: center;
}

.tableW {
  width: 600px;
  padding-left: 60px;
  margin: 10px 0px 20px;
}

.tip {
  color: #f00;
}
</style>
